import { render, staticRenderFns } from "./SkuEditableTable.vue?vue&type=template&id=658de54a&"
import script from "./SkuEditableTable.vue?vue&type=script&lang=js&"
export * from "./SkuEditableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports